import React from 'react'

const RecentSearch = ({setQ, fetchData, setIsFocused, inputRef, recentSearches = [
] }) => {


    const handleClick = (itemText) => {
        setQ(itemText);
        inputRef.current.value = itemText;
        fetchData();
        setIsFocused(false);
        inputRef.current.blur();
    }
  return (
    <div className='search-overlay-screen' style={{height: "100dvh", zIndex:"-1", width: "100%", backgroundColor: "#ffffff", position: "absolute", top: "0", left: "0", padding:"80px 16px 16px 16px"}}>
        <div className="search-overlay-heading">
            {recentSearches?.length > 0 &&<>
            <div className="search-overlay-title" style={{fontSize: "24px", color:"#1A1A1A"}}>Recent searches</div>
            <div className="search-overlay-subtitle" style={{fontSize: "14px", color:"#4D4D4D"}}>Quick access to what you searched for last.</div>
            </>}
            <div className="previous-searches" style={{marginTop:"32px"}}>
                {recentSearches?.map((search, index) => (
                    <div key={index} onClick={()=>handleClick(search)} className="previous-search-item" style={{fontSize: "16px", color:"#1A1A1A", display: "flex", alignItems:"center", gap:"12px", padding:"12px 0", borderBottom:"1px solid #00000014"}}>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 10C1 11.78 1.52784 13.5201 2.51677 15.0001C3.50571 16.4802 4.91131 17.6337 6.55585 18.3149C8.20038 18.9961 10.01 19.1743 11.7558 18.8271C13.5016 18.4798 15.1053 17.6226 16.364 16.364C17.6226 15.1053 18.4798 13.5016 18.8271 11.7558C19.1743 10.01 18.9961 8.20038 18.3149 6.55585C17.6337 4.91131 16.4802 3.50571 15.0001 2.51677C13.5201 1.52784 11.78 1 10 1C7.48395 1.00947 5.06897 1.99122 3.26 3.74L1 6M1 6V1M1 6H6M10 5V10L13 12" stroke="#6C6C6C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

                        {search}
                    </div>
                ))}
            </div>
        </div>
    </div>
  )
}

export default RecentSearch